<div>
	@if (loading()) {
		<nz-spin nzSimple nzSize="large"></nz-spin>
	}

	@if (!loading() && allClientLocations().length > 0) {
		<nz-select
			[nzMaxTagCount]="3"
			[nzMaxTagPlaceholder]="tagPlaceHolder"
			nzMode="multiple"
			nzPlaceHolder="Please select"
			[(ngModel)]="selectedLocationUuids"
			(ngModelChange)="onSelectionChange($event)"
		>
			@for (clientLocation of allClientLocations(); track clientLocation.client.uuid) {
				@for (location of clientLocation.locations; track location.uuid) {
					<nz-option
						[nzLabel]="
							(clientLocation.client.active_text?.name || clientLocation.client.subdomain) +
							' - ' +
							location.name
						"
						[nzValue]="location.uuid"
					></nz-option>
				}
			}
		</nz-select>
		<ng-template #tagPlaceHolder let-selectedList>and {{ selectedList.length }} more selected</ng-template>
	}
</div>
